class MainNavObserver {

  static init(params) {
    const mainNav = document.querySelectorAll(params.selMainNav);

    mainNav.forEach(mainNav => {
      new MainNavObserver(mainNav, params);
    })
  }



  constructor(mainNav, params) {
    this.mainNav = mainNav;    
    this.getCssProperty = params.getCssProperty;
    this.scrollWatcher = this.createScrollWatcher();
    this.observeScrollWatcher();
  }



  createScrollWatcher() {
    const spaceToEdge = 60;
    const mainNavHeight = this.mainNav.clientHeight;
    const posScrollWatcher = parseInt(spaceToEdge) + parseInt(mainNavHeight);
    const scrollWatcher = document.createElement('div');

    scrollWatcher.setAttribute('data-scrollwatcher', '');
    scrollWatcher.style.cssText = `
      position: absolute;
      inset: ${posScrollWatcher}px 0 auto;
    `;

    this.mainNav.after(scrollWatcher);
    return scrollWatcher;
  }



  observeScrollWatcher() {
    const observer = new IntersectionObserver((entries) => {
      this.mainNav.classList.toggle('is-stuck', !entries[0].isIntersecting);
    });

    observer.observe(this.scrollWatcher);
  }
}